<template>
  <DxPopup
    :visible="loadingVisible"
    title="Loading data..."
    :drag-enabled="false"
    :hide-on-outside-click="false"
    width="300"
    :height="130"
  >
    <div class="d-flex justify-content-center">
      <div
        class="spinner-border"
        style="width: 3rem; height: 3rem"
        role="status"
      ></div>
    </div>
  </DxPopup>
  <div class="content-block">
    <div class="dx-card responsive-paddings">
      <p class="text-muted font-weight-light fs-6 fw-bold">
        Prediksi KP, KGB & Pensiun
        <span>
          <DxButton
            icon="refresh"
            @click="refresh()"
            text="Refresh"
            type="default"
            styling-mode="outlined"
          ></DxButton>
        </span>
      </p>
      <div class="row row-cols-1 row-cols-md-4 g-4">
        <div class="col">
          <div
            class="card text-black mb-3"
            style="background-color: red !important"
          >
            <div
              class="dashboard-card"
              style="color: black"
              @click="
                handleClickNotif(
                  'dashboard_data_prediksi_kp_april',
                  `Prediksi KP April ${notifTodayYear}`,
                )
              "
            >
              <div class="card-body">
                <h4
                  class="card-title"
                  style="font-weight: bold; color: aliceblue"
                >
                  <div v-if="notifDashboard">
                    {{
                      notifDashboard["dashboard_data_prediksi_kp_april"] ?? 0
                    }}
                  </div>
                </h4>
                <p class="card-text" style="font-weight: bold; font-size: 16px">
                  Prediksi KP April
                  {{ notifTodayYear }}
                </p>
              </div>
            </div>
          </div>
        </div>

        <div class="col">
          <div
            class="card text-black mb-3"
            style="background-color: red !important"
          >
            <div
              class="dashboard-card"
              style="color: black"
              @click="
                handleClickNotif(
                  'dashboard_data_prediksi_kgb_april',
                  `Prediksi KGB April ${notifTodayYear}`,
                )
              "
            >
              <div class="card-body">
                <h4
                  class="card-title"
                  style="font-weight: bold; color: aliceblue"
                >
                  <div v-if="notifDashboard">
                    {{
                      notifDashboard["dashboard_data_prediksi_kgb_april"] ?? 0
                    }}
                  </div>
                </h4>
                <p class="card-text" style="font-weight: bold; font-size: 16px">
                  Prediksi KGB April
                  {{ notifTodayYear }}
                </p>
              </div>
            </div>
          </div>
        </div>

        <div class="col">
          <div
            class="card text-black mb-3"
            style="background-color: rgba(148, 215, 199, 0.8) !important"
          >
            <div
              class="dashboard-card"
              style="color: black"
              @click="
                handleClickNotif(
                  'dashboard_data_pensiun_current_month',
                  `Pegawai Pensiun ${notifTodayMonth} ${notifTodayYear}`,
                  true, //utk nama bukan pegawai.nama
                )
              "
            >
              <div class="card-body">
                <h4
                  class="card-title"
                  style="font-weight: bold; color: aliceblue"
                >
                  <div v-if="notifDashboard">
                    {{ notifDashboard["dashboard_data_pensiun_current_month"] }}
                  </div>
                </h4>
                <p class="card-text" style="font-weight: bold; font-size: 16px">
                  Pegawai Pensiun {{ notifTodayMonth }}
                  {{ notifTodayYear }}
                </p>
              </div>
            </div>
          </div>
        </div>

        <div class="col">
          <div
            class="card text-black mb-3"
            style="background-color: rgba(123, 155, 207, 0.8) !important"
          >
            <a
              href="#"
              class="dashboard-card"
              style="color: black"
              @click="
                handleClickNotif(
                  'dashboard_data_pengajuan_kp',
                  `Pengajuan Penetapan KP`,
                )
              "
            >
              <div class="card-body">
                <h4
                  class="card-title"
                  style="font-weight: bold; color: aliceblue"
                >
                  <div v-if="notifDashboard">
                    {{ notifDashboard["dashboard_data_pengajuan_kp"] ?? 0 }}
                  </div>
                </h4>
                <p class="card-text" style="font-weight: bold; font-size: 16px">
                  Pengajuan Penetapan KP
                </p>
              </div>
            </a>
          </div>
        </div>

        <div class="col">
          <div
            class="card text-black mb-3"
            style="background-color: #673ab7 !important"
          >
            <div
              class="dashboard-card"
              style="color: black"
              @click="
                handleClickNotif(
                  'dashboard_data_prediksi_kp_october',
                  `Prediksi KP Oktober ${notifNextYear}`,
                )
              "
            >
              <div class="card-body">
                <h4
                  class="card-title"
                  style="font-weight: bold; color: aliceblue"
                >
                  <div v-if="notifDashboard">
                    {{
                      notifDashboard["dashboard_data_prediksi_kp_october"] ?? 0
                    }}
                  </div>
                </h4>
                <p class="card-text" style="font-weight: bold; font-size: 16px">
                  Prediksi KP Oktober
                  {{ notifTodayYear }}
                </p>
              </div>
            </div>
          </div>
        </div>

        <div class="col">
          <div
            class="card text-black mb-3"
            style="background-color: #673ab7 !important"
          >
            <div
              class="dashboard-card"
              style="color: black"
              @click="
                handleClickNotif(
                  'dashboard_data_prediksi_kgb_october',
                  `Prediksi KGB Oktober ${notifTodayYear}`,
                )
              "
            >
              <div class="card-body">
                <h4
                  class="card-title"
                  style="font-weight: bold; color: aliceblue"
                >
                  <div v-if="notifDashboard">
                    {{
                      notifDashboard["dashboard_data_prediksi_kgb_october"] ?? 0
                    }}
                  </div>
                </h4>
                <p class="card-text" style="font-weight: bold; font-size: 16px">
                  Prediksi KGB Oktober
                  {{ notifTodayYear }}
                </p>
              </div>
            </div>
          </div>
        </div>

        <div class="col">
          <div
            class="card text-black mb-3"
            style="background-color: rgba(148, 215, 199, 0.8) !important"
          >
            <div
              class="dashboard-card"
              style="color: black"
              @click="
                handleClickNotif(
                  'dashboard_data_pensiun_next_month',
                  `Pegawai Pensiun ${notifNextMonth} ${notifNextYear}`,
                  true, //utk nama bukan pegawai.nama
                )
              "
            >
              <div class="card-body">
                <h4
                  class="card-title"
                  style="font-weight: bold; color: aliceblue"
                >
                  <div v-if="notifDashboard">
                    {{ notifDashboard["dashboard_data_pensiun_next_month"] }}
                  </div>
                </h4>
                <p class="card-text" style="font-weight: bold; font-size: 16px">
                  Pegawai Pensiun {{ notifNextMonth }} {{ notifNextYear }}
                </p>
              </div>
            </div>
          </div>
        </div>

        <div class="col">
          <div
            class="card text-black mb-3"
            style="background-color: rgba(123, 155, 207, 0.8) !important"
          >
            <a
              href="#"
              class="dashboard-card"
              style="color: black"
              @click="
                handleClickNotif(
                  'dashboard_data_pengajuan_kgb',
                  `Pengajuan Penetapan KGB`,
                )
              "
            >
              <div class="card-body">
                <h4
                  class="card-title"
                  style="font-weight: bold; color: aliceblue"
                >
                  <div v-if="notifDashboard">
                    {{ notifDashboard["dashboard_data_pengajuan_kgb"] ?? 0 }}
                  </div>
                </h4>
                <p class="card-text" style="font-weight: bold; font-size: 16px">
                  Pengajuan Penetapan KGB
                </p>
              </div>
            </a>
          </div>
        </div>

        <div class="col">
          <div
            class="card text-black mb-3"
            style="background-color: rgba(243, 158, 108, 0.8) !important"
          >
            <div
              class="dashboard-card"
              style="color: black"
              @click="
                handleClickNotif(
                  'dashboard_data_pengabdian',
                  `Prediksi KP Pengabdian ${notifTodayMonth} ${notifNextYear}`,
                  true,
                )
              "
            >
              <div class="card-body">
                <h4
                  class="card-title"
                  style="font-weight: bold; color: aliceblue"
                >
                  <div v-if="notifDashboard">
                    {{ notifDashboard["dashboard_data_pengabdian"] }}
                  </div>
                </h4>
                <p class="card-text" style="font-weight: bold; font-size: 16px">
                  Prediksi KP Pengabdian {{ notifTodayMonth }}
                  {{ notifNextYear }}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="col">
          <div
            class="card text-black mb-3"
            style="background-color: rgba(243, 158, 108, 0.8) !important"
          >
            <div
              href="#"
              class="dashboard-card"
              style="color: black"
              @click="
                handleClickNotif(
                  'dashboard_data_pengabdian_next_month',
                  `Prediksi KP Pengabdian ${notifNextMonth} ${notifTodayYear}`,
                  true,
                )
              "
            >
              <div class="card-body">
                <h4
                  class="card-title"
                  style="font-weight: bold; color: aliceblue"
                >
                  <div v-if="notifDashboard">
                    {{
                      notifDashboard["dashboard_data_pengabdian_next_month"] ??
                      0
                    }}
                  </div>
                </h4>
                <p class="card-text" style="font-weight: bold; font-size: 16px">
                  Prediksi KP Pengabdian {{ notifNextMonth }}
                  {{ notifTodayYear }}
                </p>
              </div>
            </div>
          </div>
        </div>

        <div class="col">
          <div
            class="card text-black mb-3"
            style="background-color: rgba(148, 215, 199, 0.8) !important"
          >
            <div
              class="dashboard-card"
              style="color: black"
              @click="
                handleClickNotif(
                  'dashboard_data_pensiun_current_year',
                  `Total Pegawai Pensiun ${notifTodayYear}`,
                  true, //utk nama bukan pegawai.nama
                )
              "
            >
              <div class="card-body">
                <h4
                  class="card-title"
                  style="font-weight: bold; color: aliceblue"
                >
                  <div v-if="notifDashboard">
                    {{ notifDashboard["dashboard_data_pensiun_current_year"] }}
                  </div>
                </h4>
                <p class="card-text" style="font-weight: bold; font-size: 16px">
                  Total Pegawai Pensiun {{ notifTodayYear }}
                </p>
              </div>
            </div>
          </div>
        </div>

        <!-- <div class="col">
          <div
            class="card text-black mb-3"
            style="background-color: rgba(123, 155, 207, 0.8) !important"
          >
            <a
              href="#"
              class="dashboard-card"
              style="color: black"
              @click="
                handleClickNotif(
                  'totalPengajuanList',
                  `Total Pengajuan Penetapan KP KGB`,
                )
              "
            >
              <div class="card-body">
                <h4
                  class="card-title"
                  style="font-weight: bold; color: aliceblue"
                >
                  <div v-if="notifDashboard">
                    {{ notifDashboard["totalPengajuan"] }}
                  </div>
                </h4>
                <p class="card-text" style="font-weight: bold; font-size: 16px">
                  Total Pengajuan Penetapan KP KGB
                </p>
              </div>
            </a>
          </div>
        </div> -->
      </div>
    </div>
  </div>

  <div class="content-block" v-if="summaryLogData">
    <div class="dx-card responsive-paddings">
      <p class="text-muted font-weight-light fs-6 fw-bold">
        Rangkuman Aktivitas User {{ notifTodayMonth }}
        {{ notifTodayYear }}

        <a href="#/activity-log" style="padding-left: 10px"
          >Lihat Log Aktivitas User</a
        >
      </p>

      <ActivityUserRankTemplate :userData="summaryLogData" />
    </div>
  </div>

  <div class="content-block">
    <div class="dx-card responsive-paddings">
      <p class="text-muted font-weight-light fs-6 fw-bold">
        Rangkuman Statistik Kepegawaian Perusahaan {{ notifTodayMonth }}
        {{ notifTodayYear }}
      </p>

      <div class="row row-cols-1 row-cols-md-6 g-4">
        <div class="col">
          <div class="card h-100">
            <a
              href="#"
              class="dashboard-card"
              style="color: black"
              @click="
                handleClickNotif(
                  'dashboard_data_pegawai_aktif',
                  `Daftar Pegawai Aktif ${notifTodayMonth} ${notifTodayYear}`,
                  true, //utk nama bukan pegawai.nama
                )
              "
            >
              <div class="card-body">
                <h5 class="card-title" v-if="notifDashboard">
                  {{ notifDashboard["dashboard_data_pegawai_aktif"] }}
                </h5>
                <p class="card-text">Pegawai Aktif</p>
              </div>
            </a>
          </div>
        </div>
        <div class="col">
          <div class="card h-100">
            <a
              href="#"
              class="dashboard-card"
              style="color: black"
              @click="
                handleClickNotif(
                  'dashboard_data_direksi',
                  `Daftar Direksi ${notifTodayMonth} ${notifTodayYear}`,
                  true, //utk nama bukan pegawai.nama
                )
              "
            >
              <div class="card-body">
                <h5 class="card-title" v-if="notifDashboard">
                  {{ notifDashboard["dashboard_data_direksi"] }}
                </h5>
                <p class="card-text">Direksi</p>
              </div>
            </a>
          </div>
        </div>

        <div class="col">
          <div class="card h-100">
            <a
              href="#"
              class="dashboard-card"
              style="color: black"
              @click="
                handleClickNotif(
                  'dashboard_data_pegawai_tetap',
                  `Daftar Pegawai Tetap ${notifTodayMonth} ${notifTodayYear}`,
                  true, //utk nama bukan pegawai.nama
                )
              "
            >
              <div class="card-body">
                <h5 class="card-title" v-if="notifDashboard">
                  {{ notifDashboard["dashboard_data_pegawai_tetap"] }}
                </h5>
                <p class="card-text">Pegawai Tetap</p>
              </div>
            </a>
          </div>
        </div>
        <div class="col">
          <div class="card h-100">
            <a
              href="#"
              class="dashboard-card"
              style="color: black"
              @click="
                handleClickNotif(
                  'dashboard_data_capeg',
                  `Daftar Pegawai Capeg ${notifTodayMonth} ${notifTodayYear}`,
                  true, //utk nama bukan pegawai.nama
                )
              "
            >
              <div class="card-body">
                <h5 class="card-title" v-if="notifDashboard">
                  {{ notifDashboard["dashboard_data_capeg"] }}
                </h5>
                <p class="card-text">Pegawai Capeg</p>
              </div>
            </a>
          </div>
        </div>
        <div class="col">
          <div class="card h-100">
            <a
              href="#"
              class="dashboard-card"
              style="color: black"
              @click="
                handleClickNotif(
                  'dashboard_data_pegawai_honor',
                  `Daftar Pekerja Honor ${notifTodayMonth} ${notifTodayYear}`,
                  true,
                )
              "
            >
              <div class="card-body">
                <h5 class="card-title" v-if="notifDashboard">
                  {{ notifDashboard["dashboard_data_pegawai_honor"] }}
                </h5>
                <p class="card-text">Pekerja Honor</p>
              </div>
            </a>
          </div>
        </div>
        <div class="col">
          <div class="card h-100">
            <a
              href="#"
              class="dashboard-card"
              style="color: black"
              @click="
                handleClickNotif(
                  'dashboard_data_pegawai_kontrak',
                  `Daftar Pekerja Kontrak ${notifTodayMonth} ${notifTodayYear}`,
                  true, //utk nama bukan pegawai.nama
                )
              "
            >
              <div class="card-body">
                <h5 class="card-title" v-if="notifDashboard">
                  {{ notifDashboard["dashboard_data_pegawai_kontrak"] }}
                </h5>
                <p class="card-text">Pekerja Kontrak</p>
              </div>
            </a>
          </div>
        </div>

        <div class="col">
          <div class="card h-100">
            <a
              href="#"
              class="dashboard-card"
              style="color: black"
              @click="
                handleClickNotif(
                  'dashboard_data_dewas',
                  `Daftar Dewan Pengawas ${notifTodayMonth} ${notifTodayYear}`,
                  true, //utk nama bukan pegawai.nama
                )
              "
            >
              <div class="card-body">
                <h5 class="card-title" v-if="notifDashboard">
                  {{ notifDashboard["dashboard_data_dewas"] }}
                </h5>
                <p class="card-text">Dewan Pengawas</p>
              </div>
            </a>
          </div>
        </div>

        <div class="col">
          <div class="card h-100">
            <a
              href="#"
              class="dashboard-card"
              style="color: black"
              @click="
                handleClickNotif(
                  'dashboard_data_dewas_staf',
                  `Daftar Sekretariat Dewan Pengawas ${notifTodayMonth} ${notifTodayYear}`,
                  true, //utk nama bukan pegawai.nama
                )
              "
            >
              <div class="card-body">
                <h5 class="card-title" v-if="notifDashboard">
                  {{ notifDashboard["dashboard_data_dewas_staf"] }}
                </h5>
                <p class="card-text">Sekretariat Dewan Pengawas</p>
              </div>
            </a>
          </div>
        </div>

        <div class="col">
          <div class="card h-100">
            <a
              href="#"
              class="dashboard-card"
              style="color: black"
              @click="
                handleClickNotif(
                  'dashboard_data_pensiun',
                  `Daftar Pegawai Pensiun ${notifTodayMonth} ${notifTodayYear}`,
                  true, //utk nama bukan pegawai.nama
                )
              "
            >
              <div class="card-body">
                <h5 class="card-title" v-if="notifDashboard">
                  {{ notifDashboard["dashboard_data_pensiun"] }}
                </h5>
                <p class="card-text">Pegawai Pensiun</p>
              </div>
            </a>
          </div>
        </div>

        <div class="col">
          <div class="card h-100">
            <a
              href="#"
              class="dashboard-card"
              style="color: black"
              @click="
                handleClickNotif(
                  'dashboard_data_smp',
                  `Daftar Pegawai Pendidikan Terakhir SMP/Setara ${notifTodayMonth} ${notifTodayYear}`,
                  true,
                )
              "
            >
              <div class="card-body">
                <h5 class="card-title" v-if="notifDashboard">
                  {{ notifDashboard["dashboard_data_smp"] }}
                </h5>
                <p class="card-text">Pendidikan Terakhir SMP/Setara</p>
              </div>
            </a>
          </div>
        </div>
        <div class="col">
          <div class="card h-100">
            <a
              href="#"
              class="dashboard-card"
              style="color: black"
              @click="
                handleClickNotif(
                  'dashboard_data_sma',
                  `Daftar Pegawai Pendidikan Terakhir SMA/Setara ${notifTodayMonth} ${notifTodayYear}`,
                  true, //utk nama bukan pegawai.nama
                )
              "
            >
              <div class="card-body">
                <h5 class="card-title" v-if="notifDashboard">
                  {{ notifDashboard["dashboard_data_sma"] }}
                </h5>
                <p class="card-text">Pendidikan Terakhir SMA/Setara</p>
              </div>
            </a>
          </div>
        </div>
        <div class="col">
          <div class="card h-100">
            <a
              href="#"
              class="dashboard-card"
              style="color: black"
              @click="
                handleClickNotif(
                  'dashboard_data_d1',
                  `Daftar Pegawai Pendidikan Terakhir Diploma I ${notifTodayMonth} ${notifTodayYear}`,
                  true, //utk nama bukan pegawai.nama
                )
              "
            >
              <div class="card-body">
                <h5 class="card-title" v-if="notifDashboard">
                  {{ notifDashboard["dashboard_data_d1"] }}
                </h5>
                <p class="card-text">Pendidikan Terakhir Diploma I</p>
              </div>
            </a>
          </div>
        </div>
        <div class="col">
          <div class="card h-100">
            <a
              href="#"
              class="dashboard-card"
              style="color: black"
              @click="
                handleClickNotif(
                  'dashboard_data_d2',
                  `Daftar Pegawai Pendidikan Terakhir Diploma II ${notifTodayMonth} ${notifTodayYear}`,
                  true, //utk nama bukan pegawai.nama
                )
              "
            >
              <div class="card-body">
                <h5 class="card-title" v-if="notifDashboard">
                  {{ notifDashboard["dashboard_data_d2"] }}
                </h5>
                <p class="card-text">Pendidikan Terakhir Diploma II</p>
              </div>
            </a>
          </div>
        </div>
        <div class="col">
          <div class="card h-100">
            <a
              href="#"
              class="dashboard-card"
              style="color: black"
              @click="
                handleClickNotif(
                  'dashboard_data_d3',
                  `Daftar Pegawai Pendidikan Terakhir Diploma III ${notifTodayMonth} ${notifTodayYear}`,
                  true, //utk nama bukan pegawai.nama
                )
              "
            >
              <div class="card-body">
                <h5 class="card-title" v-if="notifDashboard">
                  {{ notifDashboard["dashboard_data_d3"] }}
                </h5>
                <p class="card-text">Pendidikan Terakhir Diploma III</p>
              </div>
            </a>
          </div>
        </div>
        <div class="col">
          <div class="card h-100">
            <a
              href="#"
              class="dashboard-card"
              style="color: black"
              @click="
                handleClickNotif(
                  'dashboard_data_d4',
                  `Daftar Pegawai Pendidikan Terakhir Diploma IV ${notifTodayMonth} ${notifTodayYear}`,
                  true, //utk nama bukan pegawai.nama
                )
              "
            >
              <div class="card-body">
                <h5 class="card-title" v-if="notifDashboard">
                  {{ notifDashboard["dashboard_data_d4"] }}
                </h5>
                <p class="card-text">Pendidikan Terakhir Diploma IV</p>
              </div>
            </a>
          </div>
        </div>
        <div class="col">
          <div class="card h-100">
            <a
              href="#"
              class="dashboard-card"
              style="color: black"
              @click="
                handleClickNotif(
                  'dashboard_data_s1',
                  `Daftar Pegawai Pendidikan Terakhir S1 ${notifTodayMonth} ${notifTodayYear}`,
                  true, //utk nama bukan pegawai.nama
                )
              "
            >
              <div class="card-body">
                <h5 class="card-title" v-if="notifDashboard">
                  {{ notifDashboard["dashboard_data_s1"] }}
                </h5>
                <p class="card-text">Pendidikan Terakhir S1</p>
              </div>
            </a>
          </div>
        </div>
        <div class="col">
          <div class="card h-100">
            <a
              href="#"
              class="dashboard-card"
              style="color: black"
              @click="
                handleClickNotif(
                  'dashboard_data_s2',
                  `Daftar Pegawai Pendidikan Terakhir S2 ${notifTodayMonth} ${notifTodayYear}`,
                  true, //utk nama bukan pegawai.nama
                )
              "
            >
              <div class="card-body">
                <h5 class="card-title" v-if="notifDashboard">
                  {{ notifDashboard["dashboard_data_s2"] }}
                </h5>
                <p class="card-text">Pendidikan Terakhir S2</p>
              </div>
            </a>
          </div>
        </div>
        <div class="col">
          <div class="card h-100">
            <a
              href="#"
              class="dashboard-card"
              style="color: black"
              @click="
                handleClickNotif(
                  'dashboard_data_penyesuaian',
                  `Daftar Pegawai Penyesuaian ${notifTodayMonth} ${notifTodayYear}`,
                  false, //utk pegawai.nama
                )
              "
            >
              <div class="card-body">
                <h5 class="card-title" v-if="notifDashboard">
                  {{ notifDashboard["dashboard_data_penyesuaian"] }}
                </h5>
                <p class="card-text">Pegawai Penyesuaian</p>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="content-block">
    <div class="row row-cols-1 row-cols-md-2">
      <div class="col">
        <div class="dx-card responsive-paddings">
          <PieComponent
            v-if="notifDashboard"
            :dsProp="notifDashboard['dashboard_chart_pegawai_status']"
            titleProp="Berdasarkan Status Pegawai"
            argumentFieldProp="nama"
            pointClickProp="pegawai_status_id"
            dataGridFilterArgProp=""
          />
        </div>
      </div>
      <div class="col">
        <div class="dx-card responsive-paddings">
          <PieComponent
            v-if="notifDashboard"
            :dsProp="notifDashboard['dashboard_chart_jenis_kelamin']"
            titleProp="Berdasarkan Gender Pegawai"
            argumentFieldProp="jenis_kelamin"
            pointClickProp="jenis_kelamin"
          />
        </div>
      </div>
      <div class="col">
        <div class="dx-card responsive-paddings">
          <PieComponent
            v-if="notifDashboard"
            :dsProp="notifDashboard['dashboard_chart_cabang']"
            titleProp="Berdasarkan Cabang"
            argumentFieldProp="nama"
            pointClickProp="cabang_id"
            dataGridFilterArgProp="riwayatPekerjaans[0]."
          />
        </div>
      </div>
      <div class="col">
        <div class="dx-card responsive-paddings">
          <PieComponent
            v-if="notifDashboard"
            :dsProp="notifDashboard['dashboard_chart_golongan']"
            titleProp="Berdasarkan Golongan"
            argumentFieldProp="nama"
            pointClickProp="golongan_id"
            dataGridFilterArgProp="simpegNaikPangkats[0]."
          />
        </div>
      </div>
      <div class="col">
        <div class="dx-card responsive-paddings">
          <PieComponent
            v-if="notifDashboard"
            :dsProp="notifDashboard['dashboard_chart_umur']"
            titleProp="Berdasarkan Umur"
            argumentFieldProp="nama"
            pointClickProp="tgl_lahir"
          />
        </div>
      </div>
      <div class="col">
        <div class="dx-card responsive-paddings">
          <PieComponent
            v-if="notifDashboard"
            :dsProp="notifDashboard['dashboard_chart_masa_kerja']"
            titleProp="Berdasarkan Masa Kerja"
            argumentFieldProp="nama"
          />
        </div>
      </div>
      <div class="col">
        <div class="dx-card responsive-paddings">
          <PieComponent
            v-if="notifDashboard"
            :dsProp="notifDashboard['dashboard_chart_pendidikan']"
            titleProp="Berdasarkan Jenjang Pendidikan Terakhir"
            argumentFieldProp="nama"
          />
        </div>
      </div>
    </div>
  </div>

  <DxPopup
    :width="660"
    :height="540"
    :show-title="true"
    :title="currentNotifTitle"
    :drag-enabled="false"
    :hide-on-outside-click="true"
    v-model:visible="popupVisible"
  >
    <template #content>
      Total: {{ currentNotifCount }}
      <div>
        <div class="list-container">
          <DxList
            ref="dxList"
            :data-source="currentNotifDataSource"
            :height="400"
            :search-enabled="true"
            search-mode="contains"
            :search-expr="showPegawaiPopup ? 'nama' : 'pegawai.nama'"
            @item-click="handlePopupClick"
          >
            <template #item="{ data }">
              <div>
                <div v-if="!showPegawaiPopup">
                  {{ data.pegawai.nama }}
                  <strong>{{ data.pegawai.nik }}</strong>
                </div>
                <div v-if="showPegawaiPopup">
                  {{ data.nama }} <strong> {{ data.nik }}</strong>
                </div>
                <div v-if="showGolonganPopup">
                  <strong>Tgl </strong>{{ convertTglFormat(data.tgl) }}
                  <strong>Gol.</strong>
                  {{ printGolongan(data) }}
                  {{ data.jenis_naik_pangkat }}
                  <strong>Masa Kerja</strong>
                  {{ data.masa_kerja }} tahun {{ data.masa_kerja_bulan }} bulan
                </div>
                <div v-if="showMasaKerjaPopup">
                  <strong>Tgl </strong>{{ convertTglFormat(data.tgl) }}
                  <strong>Masa Kerja</strong>
                  {{ data.masa_kerja }} tahun {{ data.masa_kerja_bulan }} bulan
                </div>

                <div v-if="showPensiunPopup">
                  <strong>Tgl Pensiun </strong
                  >{{ convertTglFormat(data.pensiun_tgl) }}
                </div>
              </div>
            </template>
          </DxList>
        </div>
        <!-- <div class="options">
        <div class="caption">Options</div>
        <div class="option">
          <span>Search mode </span>
          <DxSelectBox
            :items="['contains', 'startsWith', 'equals']"
            :input-attr="{ 'aria-label': 'Search Mode' }"
            v-model:value="searchMode"
          />
        </div>
      </div> -->
      </div>
    </template>
  </DxPopup>
</template>

<!-- <style lang="scss"></style> -->
<style scoped>
.col-labels {
  display: grid;
  grid-template-columns: 2.5rem 1fr 140px 140px 80px;
  padding: 0 0.75rem;
  margin-bottom: 0.4rem;
  font-size: 0.65rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  color: #9ca3af;
}
</style>

<script>
// import DxChart, { DxArgumentAxis } from "devextreme-vue/chart";
// import {
//   // DxPieChart,
//   // DxSeries,
//   // DxExport,
//   // DxTooltip,
//   // DxLegend,
//   // DxLabel,
//   // DxConnector,
// } from "devextreme-vue/pie-chart";
import * as commonFunction from "@/utils/common-function.js";
import { useAppStore } from "@/stores/UseAppStore";
import DxButton from "devextreme-vue/button";
import PieComponent from "./PieComponent.vue";
import DxPopup from "devextreme-vue/popup";
import api from "@/api";
import { API_BASE_URL } from "@/global-constants";
// import DataSource from "devextreme/data/data_source";
import router from "@/router";
import { populationData } from "./populationData.js";
import { DateTime } from "luxon";
// import axios from "axios";
// import CenterTemplate from "./CenterTemplate.vue";
import DxList from "devextreme-vue/list";
import ActivityUserRankTemplate from "./ActivityUserRankTemplate.vue";

function notifDate(q) {
  const today = DateTime.local().setLocale("id");
  const nextMonth = today.plus({ months: 1 });

  if (q == "todayMonth") return today.month;
  if (q == "todayYear") return today.year;
  if (q == "nextMonth") return nextMonth.month;
  if (q == "nextYear") return nextMonth.year;
  if (q == "todayMonthLong") return today.monthLong;
  if (q == "nextMonthLong") return nextMonth.monthLong;
}

export default {
  components: {
    // DxChart,
    // DxArgumentAxis,
    // DxLabel,
    // DxLegend,
    // DxSeries,
    // DxPieChart,
    // DxExport,
    // DxTooltip,
    // DxConnector,
    // CenterTemplate,
    PieComponent,
    DxPopup,
    DxList,
    DxButton,
    ActivityUserRankTemplate,
  },
  setup() {
    const appStore = useAppStore();
    return {
      commonFunction,
      appStore,
    };
  },
  data() {
    return {
      rangkumanFilter: null,
      popupVisible: false,
      rangkumanSearchExpr: false,
      currentNotifDataSource: null,
      currentNotifCount: null,
      currentNotifTitle: null,
      dsChart: null,
      router: router,
      notifRangkuman: [],
      tandaJasa20: [],
      tandaJasa10: [],
      tandaJasa30: [],
      notifDashboard: [],
      summaryLogData: [],
      showGolonganPopup: true,
      showMasaKerjaPopup: false,
      showPensiunPopup: false,
      showPegawaiPopup: false, //pakai nama bukan pegawai.nama ketika show detail

      cacheDetail: [
        {
          name: "dashboard_data_prediksi_kp_april",
          returnArray: [
            "pegawai_id",
            "pegawai.nama",
            "pegawai.nik",
            "tgl",
            "masa_kerja",
            "masa_kerja_bulan",
            "jenis_naik_pangkat",
            "golongan.nama",
          ],
          data: [],
        },
        {
          name: "dashboard_data_prediksi_kp_october",
          returnArray: [
            "pegawai_id",
            "pegawai.nama",
            "pegawai.nik",
            "tgl",
            "masa_kerja",
            "masa_kerja_bulan",
            "jenis_naik_pangkat",
            "golongan.nama",
          ],
          data: [],
        },

        {
          name: "dashboard_data_pengabdian",
          returnArray: [
            "id",
            "nama",
            "nik",
            "tgl",
            "masa_kerja",
            "masa_kerja_bulan",
            "jenis_naik_pangkat",
            "golongan.nama",
          ],
          data: [],
        },

        {
          name: "dashboard_data_pengabdian_next_month",
          returnArray: [
            "id",
            "nama",
            "nik",
            "tgl",
            "masa_kerja",
            "masa_kerja_bulan",
            "jenis_naik_pangkat",
            "golongan.nama",
            // "pegawai_id",
            // "pegawai.nama",
            // "pegawai.nik",
            // "tgl",
            // "masa_kerja",
            // "masa_kerja_bulan",
            // "jenis_naik_pangkat",
            // "golongan.nama",
          ],
          data: [],
        },

        {
          name: "dashboard_data_prediksi_kgb_april",
          returnArray: [
            "pegawai_id",
            "pegawai.nama",
            "pegawai.nik",
            "tgl",
            "masa_kerja",
            "masa_kerja_bulan",
            "jenis_naik_pangkat",
            "golongan.nama",
          ],
          data: [],
        },

        {
          name: "dashboard_data_prediksi_kgb_october",
          returnArray: [
            "pegawai_id",
            "pegawai.nama",
            "pegawai.nik",
            "tgl",
            "masa_kerja",
            "masa_kerja_bulan",
            "jenis_naik_pangkat",
            "golongan.nama",
          ],
          data: [],
        },

        {
          name: "dashboard_data_smp",
          returnArray: ["id", "nama", "nik"],
          data: [],
        },

        {
          name: "dashboard_data_sma",
          returnArray: ["id", "nama", "nik"],
          data: [],
        },
        {
          name: "dashboard_data_d1",
          returnArray: ["id", "nama", "nik"],
          data: [],
        },
        {
          name: "dashboard_data_d2",
          returnArray: ["id", "nama", "nik"],
          data: [],
        },
        {
          name: "dashboard_data_d3",
          returnArray: ["id", "nama", "nik"],
          data: [],
        },
        {
          name: "dashboard_data_d4",
          returnArray: ["id", "nama", "nik"],
          data: [],
        },
        {
          name: "dashboard_data_s1",
          returnArray: ["id", "nama", "nik"],
          data: [],
        },
        {
          name: "dashboard_data_s2",
          returnArray: ["id", "nama", "nik"],
          data: [],
        },
        {
          name: "dashboard_data_penyesuaian",
          returnArray: ["id", "pegawai_id", "pegawai.nama", "pegawai.nik"],
          data: [],
        },
        {
          name: "dashboard_data_pensiun_current_month",
          returnArray: ["id", "nama", "nik", "pensiun_tgl"],
          data: [],
        },

        {
          name: "dashboard_data_pensiun_current_year",
          returnArray: ["id", "nama", "nik", "pensiun_tgl"],
          data: [],
        },

        {
          name: "dashboard_data_pensiun_next_month",
          returnArray: ["id", "nama", "nik", "pensiun_tgl"],
          data: [],
        },

        {
          name: "dashboard_data_pegawai_aktif",
          returnArray: ["id", "nama", "nik"],
          data: [],
        },

        {
          name: "dashboard_data_direksi",
          returnArray: ["id", "nama", "nik"],
          data: [],
        },
        {
          name: "dashboard_data_pegawai_tetap",
          returnArray: ["id", "nama", "nik"],
          data: [],
        },

        {
          name: "dashboard_data_capeg",
          returnArray: ["id", "nama", "nik"],
          data: [],
        },

        {
          name: "dashboard_data_pegawai_honor",
          returnArray: ["id", "nama", "nik"],
          data: [],
        },

        {
          name: "dashboard_data_dewas",
          returnArray: ["id", "nama"],
          // returnArray: [],
          data: [],
        },
        {
          name: "dashboard_data_dewas_staf",
          returnArray: ["id", "nama"],
          data: [],
        },

        {
          name: "dashboard_data_pensiun",
          returnArray: ["id", "nama", "nik", "pensiun_tgl"],
          data: [],
        },

        {
          name: "dashboard_data_honor",
          returnArray: ["id", "nama", "nik"],
          data: [],
        },

        {
          name: "dashboard_data_pegawai_kontrak",
          returnArray: ["id", "nama", "nik"],
          data: [],
        },

        {
          name: "dashboard_data_pengajuan_kp",
          returnArray: [
            "id",
            "pegawai_id",
            "pegawai.nama",
            "pegawai.nik",
            "golongan.nama",
            "masa_kerja",
            "masa_kerja_bulan",
            "tgl",
          ],
          data: [],
        },

        {
          name: "dashboard_data_pengajuan_kgb",
          returnArray: [
            "id",
            "pegawai_id",
            "pegawai.nama",
            "pegawai.nik",
            "golongan.nama",
            "masa_kerja",
            "masa_kerja_bulan",
            "tgl",
          ],
          data: [],
        },
      ],

      notifTodayMonth: notifDate("todayMonthLong"),
      notifNextMonth: notifDate("nextMonthLong"),
      loadingVisible: false,

      // userData: [
      //   { id: 1, name: "superadmin", visited_count: 552, mengubah_data: 27 },
      //   { id: 8, name: "Lisna", visited_count: 0, mengubah_data: 0 },
      //   { id: 9, name: "Galih", visited_count: 0, mengubah_data: 0 },
      //   { id: 10, name: "Ina", visited_count: 0, mengubah_data: 0 },
      //   { id: 11, name: "Tri", visited_count: 0, mengubah_data: 0 },
      //   { id: 12, name: "Damar", visited_count: 0, mengubah_data: 0 },
      //   { id: 15, name: "guest", visited_count: 82, mengubah_data: 0 },
      //   { id: 17, name: "Yohanes", visited_count: 3, mengubah_data: 0 },
      // ],

      notifTodayYear: notifDate("todayYear"),
      notifNextYear: notifDate("nextYear"),
      populationData,
      temperature: [2, 4, 6, 8, 9, 10, 11],
      screen(width) {
        return width < 700 ? "sm" : "lg";
      },
    };
  },
  computed: {},
  async mounted() {
    this.notifDashboard = await this.fetchDataDashboard();
    this.summaryLogData = await this.getLogSummary();
  },
  watch: {
    currentNotifDataSource() {
      this.$nextTick(() => {
        const dxListInstance = this.$refs.dxList;
        if (dxListInstance) {
          dxListInstance.instance.repaint();
        }
      });
    },
  },
  methods: {
    async getLogSummary() {
      try {
        const res = await api.post("/get-log-summary", {});
        return res.data;
      } catch (error) {
        console.error("getlogsummaryLog visit failed:", error);
        throw error;
      }
    },

    async refresh() {
      this.loadingVisible = true;
      this.notifDashboard = await this.fetchDataDashboard();
      this.activityLogData = await this.getLogSummary();

      this.loadingVisible = false;
    },
    printGolongan(e) {
      if (e.golongan) return e.golongan.nama;
      return "";
    },

    handlePopupClick(e, from = null) {
      console.log("handlePopupClick", e, from, this.currentNotifTitle);
      let pegawaiId = 0;
      // if (this.showPensiunPopup || from === "tandaJasa20")
      if (this.showPegawaiPopup) pegawaiId = e.itemData.id;
      else pegawaiId = e.itemData.pegawai_id;

      console.log("pegawaiId", pegawaiId, this.showPegawaiPopup);

      let url = "";
      let qFilter = [];
      if (
        this.currentNotifTitle &&
        this.currentNotifTitle.toLowerCase().includes("pengajuan") &&
        from === null
      ) {
        //jika dari pengajuan
        qFilter = ["pegawai_id", "=", pegawaiId];

        url = this.$router.resolve({
          name: "pengajuan-list",
          query: { filter: qFilter },
        }).href;
      } else if (
        this.currentNotifTitle &&
        this.currentNotifTitle.toLowerCase().includes("pengawas") &&
        from === null
      ) {
        url = this.$router.resolve({
          name: "dewas-detail",
          query: { id: pegawaiId },
        }).href;
      } else {
        url = this.$router.resolve({
          name: "pegawai-detail-custom",
          query: { id: pegawaiId },
        }).href;
      }

      window.open(url, "_blank");
    },

    convertTglFormat(tgl) {
      const parsedDate = DateTime.fromISO(tgl);

      // Format the date as "namaHari tanggal Bulan tahun" (Indonesian)
      const formattedDate = parsedDate.setLocale("id").toFormat("d MMMM yyyy");
      return formattedDate;
    },

    async fetchDataDashboard() {
      try {
        let tgl = DateTime.now().startOf("month").toFormat("yyyy-MM-dd");
        const response = await api.post(
          `${API_BASE_URL}/get_dashboard_cache`,
          { tgl: tgl, summary: true },
          {
            headers: {
              Authorization: api.defaults.headers.common["Authorization"],
              "Content-Type": "application/json",
            },
          },
        );

        console.log("response fetchDataDashboard", response.data.data);

        return response.data.data;
      } catch (error) {
        alert("Gagal memuat data dashboard");
        console.error("Error fetching data:", error);
      }
    },

    async handleClickNotif(cacheName, title, showPegawaiPopup = false) {
      const index = this.cacheDetail.findIndex(
        (item) => item.name === cacheName,
      );

      if (index === -1) {
        console.warn("Cache not found:", cacheName);
        return;
      }

      if (this.cacheDetail[index].data.length === 0) {
        const result = await this.fetchDataDashboardDetail(
          cacheName,
          this.cacheDetail[index].returnArray,
        );

        console.log("fetched detail for", cacheName, "result:", result);

        // ✅ reactive update
        this.cacheDetail[index].data = result;
      }

      this.currentNotifTitle = title;

      this.showGolonganPopup = this.currentNotifTitle
        .toLowerCase()
        .includes("kp");
      this.showMasaKerjaPopup = this.currentNotifTitle
        .toLowerCase()
        .includes("kgb");
      // this.showMasaKerjaPopup = this.showGolonganPopup;
      this.showPensiunPopup = this.currentNotifTitle
        .toLowerCase()
        .includes("pensiun");
      this.showPegawaiPopup = showPegawaiPopup;
      if (this.currentNotifTitle.toLowerCase().includes("kp kgb")) {
        this.showGolonganPopup = true;
        this.showMasaKerjaPopup = false;
      }

      this.currentNotifDataSource = this.cacheDetail[index].data.data;

      console.log("this.currentNotifDataSource", this.currentNotifDataSource);
      this.currentNotifCount = this.cacheDetail[index].data.data.length;

      this.popupVisible = true;
    },

    async fetchDataDashboardDetail(cacheName, returnArray) {
      try {
        let tgl = DateTime.now().startOf("month").toFormat("yyyy-MM-dd");
        const response = await api.post(
          `${API_BASE_URL}/get_dashboard_cache`,
          {
            tgl: tgl,
            summary: true,
            cache: cacheName,
            returnArray: returnArray,
          },
          {
            headers: {
              Authorization: api.defaults.headers.common["Authorization"],
              "Content-Type": "application/json",
            },
          },
        );

        console.log("response fetchDataDashboardDetail", response.data.data);

        return response.data.data;
      } catch (error) {
        alert("Gagal memuat data dashboard detail");
        console.error("Error fetching data:", error);
      }
    },
  },
};
</script>

<style>
.dx-list-item-content > div {
  padding: 5px;
  font-size: 15px;
}
</style>
